import { render } from "./CIS-ResourceRightColumnContent.vue?vue&type=template&id=54fee9b6&scoped=true"
import script from "./CIS-ResourceRightColumnContent.vue?vue&type=script&lang=js"
export * from "./CIS-ResourceRightColumnContent.vue?vue&type=script&lang=js"

import "./CIS-ResourceRightColumnContent.vue?vue&type=style&index=0&id=54fee9b6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54fee9b6"]])

export default __exports__